
<template>
    <div>
        <vs-table striped>
            <template #thead>
            <vs-tr>
                <vs-th>
                    Docente
                </vs-th>
                <vs-th>
                    Cuenta con acceso a SIGeM
                </vs-th>
                <vs-th>
                    Accedió a su cuenta
                </vs-th>
                <vs-th>
                    Acciones
                </vs-th>
            </vs-tr>
            </template>
            <template #tbody>
            <vs-tr
                :key="i"
                v-for="(tr, i) in users"
                :data="tr"
                style="border-bottom: 1px solid gray"
            >
                <vs-td class="d-flex" style="align-items:flex-start; flex-direction: column;">
                    <p class="mb-0"><strong>{{ tr.persona.apellido_paterno }} {{tr.persona.apellido_materno}} {{tr.persona.nombres}}</strong></p>
                    <p class="mb-0"><small>MATRÍCULA: </small><strong>{{ tr.persona.matricula }}</strong></p>
                    <p v-if="tr.persona.users[0]" :class="tr.persona.users[0].en_mantenimiento == 'si' ? 'mantenimiento' : 'sinMantenimiento'">Mantenimiento: <strong >{{tr.persona.users[0].en_mantenimiento}}</strong></p>
                </vs-td>
                <vs-td>
                    <div>
                        <md-chip v-if="tr.bloqueo_acceso && tr.persona.users[0]" class="mb-1 fontMedium mini-chip col-red"><strong>DOCENTE BLOQUEADO</strong></md-chip>
                        <md-chip v-if="!tr.bloqueo_acceso && tr.persona.users[0]" class="mb-1 fontMedium mini-chip col-green"><strong>Con acceso</strong></md-chip>
                        <md-chip v-if="!tr.persona.users[0]" class="mb-1 fontMedium mini-chip col-yellow"><strong>Sin acceso</strong></md-chip>
                    </div>
                </vs-td>
                <vs-td>
                    <md-chip v-if="tr.acceso == true" class="`mb-1 fontMedium mini-chip col-blue"><strong>Ya accedió</strong></md-chip>
                    <md-chip v-if="tr.acceso == false" class="mb-1 fontMedium mini-chip col-brown"><strong>No ha accedido</strong></md-chip>
                </vs-td>
                <vs-td>
                    <div class="d-flex">
                        <div>
                            <vs-tooltip>
                                <vs-button
                                    icon
                                    color="success"
                                    flat
                                    :href="'panel/docente/'+ getProfesor(tr.id)"
                                    blank
                                >
                                    <i class="far fa-address-card" style="font-size:0.8rem"></i>
                                </vs-button>
                                <template #tooltip>
                                    Ir a panel
                                </template>
                            </vs-tooltip>
                        </div>
                        <div v-if="!tr.persona.users[0]">
                            <vs-tooltip>
                                <vs-button
                                    v-if="!tr.persona.users[0]"
                                    icon
                                    color="warn"
                                    flat
                                    @click="getGenerarAccesos(tr.id)"
                                >
                                    <i class="fas fa-key" style="font-size:0.8rem"></i>
                                </vs-button>
                                <template #tooltip>
                                    Generar accesos
                                </template>
                            </vs-tooltip>
                        </div>
                        <div v-if="tr.persona.users[0]">
                            <vs-tooltip>
                                <vs-button
                                    v-if="tr.persona.users[0]"
                                    icon
                                    color="rgb(59,222,200)"
                                    flat
                                    @click="getRecuperarContrasena(tr.persona.users[0])"
                                >
                                    <i class="fas fa-eye" style="font-size:0.8rem"></i>
                                </vs-button>
                                <template #tooltip>
                                    Recuperar contraseña
                                </template>
                            </vs-tooltip>
                        </div>
                        <div v-if="!tr.bloqueo_acceso">
                            <vs-tooltip>
                                <vs-button
                                    icon
                                    color="#7d33ff"
                                    flat
                                    @click="activeVincular =! activeVincular; infoRow = tr, boton = 'editar'"
                                >
                                    <i class="fas fa-people-arrows" style="font-size:0.8rem"></i>
                                </vs-button>
                                <template #tooltip>
                                    Vincular docente
                                </template>
                            </vs-tooltip>
                        </div>
                        <div v-if="!tr.bloqueo_acceso">
                            <vs-tooltip>
                                <vs-button
                                    v-if="tr.carga_academica == false"
                                    icon
                                    color="danger"
                                    flat
                                    @click="activeDeshabilitar =! activeDeshabilitar; infoRow = tr"
                                >
                                    <i class="fas fa-user-slash" style="font-size:0.8rem"></i>
                                </vs-button>
                                <template #tooltip>
                                    Deshabilitar
                                </template>
                            </vs-tooltip>
                        </div>
                        <div v-if="!tr.bloqueo_acceso && tr.persona.users[0]">
                            <vs-tooltip>
                                <vs-button
                                    icon
                                    color="#DD0089"
                                    flat
                                    @click="activeBloquear =! activeBloquear; infoRow = tr"
                                >
                                    <i class="fas fa-ban" style="font-size:0.8rem"></i>
                                </vs-button>
                                <template #tooltip>
                                    Bloquear acceso
                                </template>
                            </vs-tooltip>
                        </div>
                    </div>
                </vs-td>
            </vs-tr>
            </template>
            <template #notFound>
                Sin información
            </template>

            <template #footer>
                <vs-pagination  v-model="page" :length="pages" />           
            </template>
        </vs-table>
        <deshabilitar v-model="activeDeshabilitar" :infoRow="infoRow" :institucion="institucion" @refreshTable="getRefresh"></deshabilitar>
        <vincular v-model="activeVincular" :instituciones="instituciones" :infoRow="infoRow" :boton="boton"></vincular>
        <bloquear v-model="activeBloquear" :infoRow="infoRow" @refreshTable="getRefresh"></bloquear>
    </div>
</template>
<script>
import academico from '../../../../api/requests/academico.js'
import deshabilitar from './modales/deshabilitar.vue'
import vincular from './modales/vincular.vue'
import bloquear from './modales/bloquear.vue'
export default {
    props: [
        'users',
        'pages',
        'institucion',
        'instituciones'
    ],
    data:() => ({
        page: 1, 
        activeDeshabilitar: false,
        activeVincular: false,
        activeBloquear: false,
        bloquear: false,
        infoRow: [],
        boton: ''
    }),
    components:{
        deshabilitar,
        vincular,
        bloquear
    },
    methods:{
        getProfesor(info){
            const dato = btoa(info)
            return dato
        },
        async getGenerarAccesos(info){
                const loading = this.$vs.loading()
            try {
                const idProf = btoa(info)
                const {data: response} = await academico.getGenerarAccesos(idProf)
                loading.close()
                this.$vs.notification({
                    progress: 'auto',
                    color: 'success',
                    position: null,
                    title: 'Operación éxitosa',
                    text: response.message
                })
            }
            catch{
                loading.close()
                this.$vs.notification({
                    progress: 'auto',
                    color: 'danger',
                    position: null,
                    title: 'Hubo un error',
                    text: 'Por favor, contacte al administrador.'
                })
            }
        },
        async getRecuperarContrasena(idProf){
                const loading = this.$vs.loading()
            try {
                const {data: response} = await academico.getRecuperarContrasena(idProf.id)
                loading.close()
                if(response.message != "No se pudo enviar el email"){
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: null,
                        title: 'Operación éxitosa',
                        text: response.message
                    })
                }else{
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: null,
                        title: 'Hubo un error',
                        text: response.message
                    })
                }
            }
            catch{
                loading.close()
                this.$vs.notification({
                    progress: 'auto',
                    color: 'danger',
                    position: null,
                    title: 'Hubo un error',
                    text: 'Por favor, contacte al administrador.'
                })
            }
        },
        getRefresh(){
            this.$emit('refreshTable', this.page)
        }
    },
    watch:{
        page(){
            this.$emit('refreshTable', this.page)
        }
    }
}
</script>

<style scoped>
    .col-red{
        color: #f62d51;
        background: rgb(249, 231, 235);
    }

    .col-green{
        color: #55ce63;
        background: rgb(232, 253, 235);
    }
    
    .col-blue{
        color: #2874A6;
        background: rgb(214, 234, 248);
    }

    .col-yellow{
        background: rgb(255, 248, 236);
        color: #febf3d;
    }

    .md-brown{
        background: #784212;
        color: white;
        border-radius: 7px;
    }
    .mantenimiento{
        border: 2px solid #febf3d;
        border-radius: 7px;
        padding: 5px;
        text-transform: uppercase;
    }
    .sinMantenimiento{
        border: 2px solid #55ce63;
        border-radius: 7px;
        padding: 5px;
        text-transform: uppercase;
    }
</style>

        